export const toCents = (amount: number) => {
  return parseInt((amount * 100).toFixed(), 10);
};
